import * as CryptoJS from 'crypto-js';


const SECRET_KEY = 'Q1JZ9R2QVTMTIzDU2Nzg5MDEyMQ1Ng==';

export const encrypt = (plainText: string): string => {
    try {
        // 1. Parse the secret key as UTF-8 bytes (matching backend's key.getBytes(StandardCharsets.UTF_8))
        const key = CryptoJS.enc.Utf8.parse(SECRET_KEY);

        // 2. Generate a random 16-byte IV
        const iv = CryptoJS.lib.WordArray.random(16);

        // 3. Encrypt: AES/CBC/PKCS5Padding (PKCS7 is compatible with PKCS5)
        // Note: CryptoJS defaults to CBC and PKCS7, but we'll be explicit
        const encrypted = CryptoJS.AES.encrypt(plainText, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        // 4. Concatenate IV and Ciphertext (matching backend's iv + encrypted)
        // Note: concat modifies the first WordArray in place
        // We clone IV to be safe though strictly unrelated here as we don't reuse IV
        const ivAndCiphertext = iv.clone().concat(encrypted.ciphertext);

        // 5. Return as Base64 string
        return CryptoJS.enc.Base64.stringify(ivAndCiphertext);
    } catch (error) {
        console.error('Encryption failed:', error);
        return plainText;
    }
};
